import _extends from "@babel/runtime/helpers/esm/extends";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { MsgContext } from "../MsgProvider/msgContext";
import { PriorityEnum, queryList, StatusEnum, transReadUnreadMsg } from "../services/api";
import { CheckOutlined, CloseOutlined, VerticalAlignTopOutlined } from '@ant-design/icons';
import { Badge, Button, ConfigProvider, Divider, List, Popover, Spin, Switch } from 'antd';
import moment from 'moment';
import useMergedState from 'rc-util/lib/hooks/useMergedState';
import React, { forwardRef, useCallback, useContext, useEffect, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import "./index.less";
var topWrapDom = /*#__PURE__*/React.createElement("div", {
  className: "mcTopIcon"
}, /*#__PURE__*/React.createElement(VerticalAlignTopOutlined, null));

//处理排序查询条件
var analyzeSorts = function analyzeSorts(sorts) {
  var resArr = [];
  sorts.forEach(function (item) {
    //某一个属性重复出现标识-过滤掉重复的属性，排序第第一个进入的为准
    var priorityRepeat,
      statusRepeat,
      timeRepeat = false;
    var _item$split = item.split('_'),
      _item$split2 = _slicedToArray(_item$split, 2),
      field = _item$split2[0],
      order = _item$split2[1];
    switch (field) {
      case 'priority':
        if (priorityRepeat) break;
        resArr.push("".concat(field, " ").concat(order === 'high' ? 'desc' : 'asc'));
        priorityRepeat = true;
        break;
      case 'status':
        if (statusRepeat) break;
        resArr.push("".concat(field, " ").concat(order === 'unread' ? 'asc' : 'desc'));
        statusRepeat = true;
        break;
      case 'time':
        if (timeRepeat) break;
        resArr.push("id ".concat(order));
        timeRepeat = true;
        break;
    }
  });
  return resArr.join(',');
};
var MsgList = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$colorPrimary = props.colorPrimary,
    colorPrimary = _props$colorPrimary === void 0 ? '#1677ff' : _props$colorPrimary,
    _props$title = props.title,
    title = _props$title === void 0 ? {
      text: 'Notifications',
      style: {
        fontSize: '24px',
        fontWeight: 500
      }
    } : _props$title,
    onlyShowUnreadDefaultChecked = props.onlyShowUnreadDefaultChecked,
    onlyShowUnreadChecked = props.onlyShowUnreadChecked,
    _props$onlyShowUnread = props.onlyShowUnreadDisabled,
    onlyShowUnreadDisabled = _props$onlyShowUnread === void 0 ? false : _props$onlyShowUnread,
    onShowOnlyUnreadChange = props.onShowOnlyUnreadChange,
    _props$topIcon = props.topIcon,
    topIcon = _props$topIcon === void 0 ? topWrapDom : _props$topIcon,
    _props$readColor = props.readColor,
    readColor = _props$readColor === void 0 ? 'rgba(0, 0, 0, 0.25)' : _props$readColor,
    unReadColor = props.unReadColor,
    _props$msgItemPop = props.msgItemPop,
    msgItemPop = _props$msgItemPop === void 0 ? {
      trigger: 'hover',
      placement: 'left'
    } : _props$msgItemPop,
    _props$listMaxHeight = props.listMaxHeight,
    listMaxHeight = _props$listMaxHeight === void 0 ? '70vh' : _props$listMaxHeight,
    _props$maxLastDay = props.maxLastDay,
    maxLastDay = _props$maxLastDay === void 0 ? 30 : _props$maxLastDay,
    _props$timeFormat = props.timeFormat,
    timeFormat = _props$timeFormat === void 0 ? 'YYYY-MM-DD HH:mm:ss' : _props$timeFormat,
    _props$pageSize = props.pageSize,
    pageSize = _props$pageSize === void 0 ? 10 : _props$pageSize,
    _props$sorts = props.sorts,
    sorts = _props$sorts === void 0 ? ['priority_high', 'status_unread', 'time_desc'] : _props$sorts,
    _props$scrollThreshol = props.scrollThreshold,
    scrollThreshold = _props$scrollThreshol === void 0 ? '100px' : _props$scrollThreshol;
  var _useContext = useContext(MsgContext),
    refresh = _useContext.refresh,
    token = _useContext.token,
    env = _useContext.env,
    count = _useContext.count,
    _setCount = _useContext._setCount,
    triggerRefresh = _useContext.triggerRefresh;

  //翻页码数
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    pageNum = _useState2[0],
    setPageNum = _useState2[1];

  //region inner only show unread checked
  var _useMergedState = useMergedState(false, {
      value: onlyShowUnreadChecked,
      defaultValue: onlyShowUnreadDefaultChecked
    }),
    _useMergedState2 = _slicedToArray(_useMergedState, 2),
    innerOnlyShowUnreadChecked = _useMergedState2[0],
    setInnerOnlyShowUnreadChecked = _useMergedState2[1];
  var onInnerShowOnlyUnreadChange = function onInnerShowOnlyUnreadChange(checked, event) {
    onShowOnlyUnreadChange === null || onShowOnlyUnreadChange === void 0 ? void 0 : onShowOnlyUnreadChange(checked, event);
    setInnerOnlyShowUnreadChecked(checked);
  };
  //endregion

  //整个列表loading
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    allLoading = _useState4[0],
    setAllLoading = _useState4[1];
  //翻页loading
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    moreLoading = _useState6[0],
    setMoreLoading = _useState6[1];
  //列表数据类型
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    data = _useState8[0],
    setData = _useState8[1];
  //还有无数据--InfiniteScroll中控制是否还能触发下滑查询
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    hasMore = _useState10[0],
    setHasMore = _useState10[1];
  //滚动区域ref
  var scrollRef = useRef({});

  //查询数据
  var loadMoreData = function loadMoreData(reload) {
    if (allLoading || moreLoading) return;
    if (reload) {
      setAllLoading(true);
    } else {
      setMoreLoading(true);
    }
    var pageNumTemp = reload ? 1 : pageNum + 1;
    queryList({
      max_days: maxLastDay,
      sorts: analyzeSorts(sorts),
      status: innerOnlyShowUnreadChecked ? StatusEnum.UNREAD : undefined,
      page_num: pageNumTemp,
      page_size: pageSize
    }, {
      token: token,
      env: env
    }).then(function (res) {
      var dataRes = res.object.data;
      if (!dataRes) {
        dataRes = [];
      }
      //若操作已读/未读，在非refresh情况下，可能查到重复数据，在此做过滤
      var dataTemp = [];
      if (!reload) {
        dataRes.forEach(function (v) {
          if (data.findIndex(function (d) {
            return d.id === v.id;
          }) === -1) {
            dataTemp.push(v);
          }
        });
      }
      setData(function (prevState) {
        return reload ? dataRes : [].concat(_toConsumableArray(prevState), dataTemp);
      });
      setHasMore(dataRes.length === pageSize);
      setPageNum(pageNumTemp);
    }).finally(function () {
      if (reload) scrollRef.current.scrollTop = 0;
      setAllLoading(false);
      setMoreLoading(false);
    });
  };

  //当接收到refresh，进行查询
  useEffect(function () {
    loadMoreData(true);
  }, [refresh, innerOnlyShowUnreadChecked]);

  //所有消息标记已读 当id为-1时代表全部标记
  var handleTransReadUnreadMsg = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id, status) {
      var dataTemp, index, unreadCount;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return transReadUnreadMsg({
              status: status,
              notifications: [id]
            }, {
              token: token,
              env: env
            });
          case 2:
            if (id === -1) {
              if (triggerRefresh) {
                triggerRefresh();
              }
            } else {
              //将当前前端数据改为已读
              dataTemp = _toConsumableArray(data);
              index = data.findIndex(function (v) {
                return v.id === id;
              });
              if (index > -1) {
                dataTemp[index].status = status;
                setData(dataTemp);
                unreadCount = count.unread - 1 < 0 ? 0 : count.unread - 1;
                _setCount({
                  unread: status === StatusEnum.READ ? unreadCount : count.unread + 1
                });
              }
            }
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleTransReadUnreadMsg(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  //消息内容气泡
  var renderContentDom = function renderContentDom(title, body) {
    return /*#__PURE__*/React.createElement("div", {
      className: "mcPopContentWrap"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mcPopContentTitle"
    }, title), /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: body
      }
    }));
  };

  //去除html标签，只展示文本
  var renderContentText = useCallback(function (text) {
    if (!text) return '';
    var tempDivElement = document.createElement('div');
    //去除<style>标签内容，否则会返回样式文本
    tempDivElement.innerHTML = text.replace(/<style(([\s\S])*?)<\/style>/g, '');
    return tempDivElement.textContent || tempDivElement.innerText || '';
  }, []);
  return /*#__PURE__*/React.createElement(ConfigProvider, {
    prefixCls: props.prefixCls || 'mc',
    theme: {
      token: {
        colorPrimary: colorPrimary
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mcWrap",
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: "mcTitle"
  }, /*#__PURE__*/React.createElement("div", {
    style: title.style
  }, title.text), /*#__PURE__*/React.createElement("div", {
    className: "mcTitleRead"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mcTitleReadText"
  }, "Only show unread"), /*#__PURE__*/React.createElement(Switch, {
    size: "small",
    checkedChildren: /*#__PURE__*/React.createElement(CheckOutlined, null),
    unCheckedChildren: /*#__PURE__*/React.createElement(CloseOutlined, null),
    checked: innerOnlyShowUnreadChecked,
    disabled: onlyShowUnreadDisabled,
    onChange: onInnerShowOnlyUnreadChange
  }))), /*#__PURE__*/React.createElement("div", {
    className: "mcHead"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mcHeadOp",
    style: {
      color: colorPrimary
    },
    onClick: function onClick() {
      return handleTransReadUnreadMsg(-1, StatusEnum.READ);
    }
  }, "Mark all as read")), /*#__PURE__*/React.createElement(Spin, {
    tip: "Loading...",
    spinning: allLoading
  }, /*#__PURE__*/React.createElement("div", {
    className: "mcListWrap"
  }, /*#__PURE__*/React.createElement("div", {
    ref: scrollRef,
    id: "scrollableDiv",
    style: {
      maxHeight: listMaxHeight,
      overflow: 'auto'
    }
  }, /*#__PURE__*/React.createElement(InfiniteScroll, {
    dataLength: data.length,
    next: loadMoreData,
    hasMore: hasMore,
    scrollThreshold: scrollThreshold //（100%减scrollThreshold）时调用next
    ,
    loader: /*#__PURE__*/React.createElement("div", {
      className: "mcMoreLoading"
    }, /*#__PURE__*/React.createElement(Spin, {
      tip: "Loading..."
    })),
    endMessage: /*#__PURE__*/React.createElement(Divider, {
      plain: true
    }, "That's all your data from the last ".concat(maxLastDay, " days.")),
    scrollableTarget: "scrollableDiv"
  }, /*#__PURE__*/React.createElement(List, {
    dataSource: data,
    renderItem: function renderItem(item) {
      return /*#__PURE__*/React.createElement(List.Item, {
        key: item.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "mcMsgItemWrap"
      }, /*#__PURE__*/React.createElement(Popover, _extends({}, msgItemPop, {
        content: function content() {
          return renderContentDom(item.title, item.body);
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "mcMsgItemPreview"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mcMsgItemPreviewHead"
      }, item.title), /*#__PURE__*/React.createElement("div", {
        className: "mcMsgItemContent"
      }, renderContentText(item.body)), /*#__PURE__*/React.createElement("div", {
        className: "mcMsgItemPreviewFoot"
      }, "published\xA0at\xA0", item.publish_date ? moment(item.publish_date).format(timeFormat) : ''))), /*#__PURE__*/React.createElement("div", {
        className: "mcMsgItemStatus"
      }, /*#__PURE__*/React.createElement(Button, {
        className: "mcMsgItemBtn",
        size: "small",
        shape: "circle",
        ghost: true,
        onClick: function onClick() {
          return handleTransReadUnreadMsg(item.id, item.status === StatusEnum.READ ? StatusEnum.UNREAD : StatusEnum.READ);
        }
      }, /*#__PURE__*/React.createElement(Badge, {
        color: item.status === StatusEnum.READ ? readColor : unReadColor || colorPrimary
      })), /*#__PURE__*/React.createElement("div", {
        className: "mcMsgItemTagWrap"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mcMsgItem",
        style: {
          color: colorPrimary,
          borderColor: colorPrimary
        }
      }, item.status === StatusEnum.READ ? 'Mark as unread' : 'Mark as read')), item.priority === PriorityEnum.HIGH ? topIcon : null)));
    }
  })))))));
});
export default MsgList;